import { render, staticRenderFns } from "./sw-forgot-password.vue?vue&type=template&id=0bc68498&scoped=true&"
import script from "./sw-forgot-password.vue?vue&type=script&lang=ts&"
export * from "./sw-forgot-password.vue?vue&type=script&lang=ts&"
import style0 from "./sw-forgot-password.vue?vue&type=style&index=0&id=0bc68498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc68498",
  null
  
)

export default component.exports